module.exports = __webpack_public_path__ + "static/img/wuhan.b72d84b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wuhan.png
// module id = EjCf
// module chunks = 3